export default {"src":"/_next/static/media/image2.e9242872.svg","height":451,"width":376,"blurWidth":0,"blurHeight":0};